import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { csvParseRows } from "d3-dsv";
export function cstParse(text) {
  var row = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (object) {
    return object;
  };
  var lines = text.trim().split(/^/gm);

  var _csvParseRows = csvParseRows(lines.shift()),
      _csvParseRows2 = _slicedToArray(_csvParseRows, 1),
      columns = _csvParseRows2[0];

  var object = objectConverter(columns);
  return cstParseLines(lines, function (array, i) {
    return row(object(array), i);
  });
}
export function cstParseRows(text) {
  var row = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (array) {
    return array;
  };
  return cstParseLines(text.trim().split(/^/gm), row);
}

function cstParseLines(lines, row) {
  var parents = [];
  var index = -1;
  parents.push({
    children: []
  });
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = lines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var line = _step.value;
      var depth = line.match(/^\s*/)[0].length;
      if (depth === line.length) continue; // Skip empty rows.

      line = line.slice(depth); // Trim indentation.

      var value = row(csvParseRows(line)[0], ++index);
      if (value == null) continue; // Filter.

      var parent = void 0;

      for (var i = depth; !(parent = parents[i]); --i) {
        ;
      } // Search for parent.


      if (!parent.children) parent.children = [];
      parent.children.push(parents[depth + 1] = value);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return parents[0].children.length === 1 ? parents[0].children[0] : parents[0];
}

function objectConverter(columns) {
  return new Function("d", "return {".concat(columns.map(function (name, i) {
    return "".concat(JSON.stringify(name), ": d[").concat(i, "]");
  }).join(), "}"));
}